import React from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import { SC_sc_workGroups } from "../../SC/__generated__/SC";
import { Table } from "antd";
import assign from "lodash.assign";
import { Button } from "antd";
import {
  UpOutlined,
  DownOutlined,
  VerticalAlignTopOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";

const CHANGEWORKGROUPGROUP = gql`
  mutation CHANGEWORKGROUPGROUP($sc: ID!, $group: Int!, $order: String!) {
    changeWorkGroupGroup(sc: $sc, group: $group, order: $order) {
      sc
    }
  }
`;

interface Props {
  sc: string;
  workGroups: SC_sc_workGroups[];
  reload: any;
}

interface ButtonValue {
  group: number;
  order: string;
  show: boolean;
}

export const Priority = ({ sc, workGroups, reload }: Props) => {
  const [changeGroup] = useMutation(CHANGEWORKGROUPGROUP);

  const handleChangeGroup = async (
    sc: string,
    group: number,
    order: string
  ) => {
    await changeGroup({ variables: { sc, group, order } });
    reload();
  };

  var children: JSX.Element[] = [];

  children.push(<h3 key={"Priority"}>Priority of Operations</h3>);

  const sorted = workGroups.sort((a, b) => b.group - a.group);

  function formatNumber(num: number) {
    num = Math.floor(num);
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  const highestButton = ({ group }: ButtonValue) => (
    <Button
      block
      onClick={() => handleChangeGroup(sc, group, "t")}
      icon={<VerticalAlignTopOutlined />}
    />
  );

  const lowestButton = ({ group }: ButtonValue) => (
    <Button
      block
      onClick={() => handleChangeGroup(sc, group, "b")}
      icon={<VerticalAlignBottomOutlined />}
    />
  );

  const moveUpButton = ({ group }: ButtonValue) => (
    <Button
      block
      onClick={() => handleChangeGroup(sc, group, "u")}
      icon={<UpOutlined />}
    />
  );
  const moveDownButton = ({ group }: ButtonValue) => (
    <Button
      block
      onClick={() => handleChangeGroup(sc, group, "d")}
      icon={<DownOutlined />}
    />
  );

  const priorityColumns = [
    {
      title: <p style={{ textAlign: "center" }}>Work Group</p>,
      dataIndex: "workGroup",
      key: "workGroup",
      render: (text: string) => <p style={{ textAlign: "center" }}>{text}</p>,
    },
    {
      title: <p style={{ textAlign: "center" }}>To Highest</p>,
      dataIndex: "highest",
      key: "highest",
      render: (value: ButtonValue) =>
        value.show ? highestButton(value) : null,
    },
    {
      title: <p style={{ textAlign: "center" }}>Move Up</p>,
      dataIndex: "moveUp",
      key: "moveUp",
      render: (value: ButtonValue) => (value.show ? moveUpButton(value) : null),
    },
    {
      title: <p style={{ textAlign: "center" }}>Move Down</p>,
      dataIndex: "moveDown",
      key: "moveDown",
      render: (value: ButtonValue) =>
        value.show ? moveDownButton(value) : null,
    },
    {
      title: <p style={{ textAlign: "center" }}>To Lowest</p>,
      dataIndex: "lowest",
      key: "lowest",
      render: (value: ButtonValue) => (value.show ? lowestButton(value) : null),
    },
  ];

  let priorityData: any = [];

  function formatItem(item: string | null, tl: number | null) {
    return tl ? item + "-" + tl : item;
  }

  const groupIDs: number[] = [];
  let firstID: number | null = null;
  let lastID: number | null = null;

  groupIDs.push(2147483647);
  sorted.forEach((q) => {
    groupIDs.push(q.group);
    if (firstID === null) {
      firstID = q.group;
    }
    lastID = q.group;
  });
  groupIDs.push(-2147483648);

  const firstGroup = firstID ? firstID : 0;
  const lastGroup = lastID ? lastID : 0;

  sorted.forEach((q, index) => {
    let description = formatNumber(q.amount) + " " + q.item + "-" + q.tl;

    if (q.deposit) {
      description += " mining Deposit # " + q.deposit;
    }

    if (q.outputItem) {
      description += " producing " + formatItem(q.outputItem, q.outputTL);
    }

    const showUp = q.group !== firstGroup;
    const showDown = q.group !== lastGroup;

    priorityData.push(
      assign({
        key: q.group,
        group: q.group,
        workGroup: description,
        highest: { group: q.group, order: "t", show: showUp },
        lowest: { group: q.group, order: "b", show: showDown },
        moveUp: { group: q.group, order: "u", show: showUp },
        moveDown: { group: q.group, order: "d", show: showDown },
      })
    );
  });

  children.push(
    <Table
      key="PriorityTable"
      size="middle"
      dataSource={priorityData}
      columns={priorityColumns}
    />
  );

  return <div>{children}</div>;
};
